"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const svg_inline_react_1 = __importDefault(require("svg-inline-react"));
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const weatherHelpers_1 = require("../../helpers/weatherHelpers");
const Icon = styled_components_1.default.div `
  &.general {
    svg {
      path,
      polygon {
        fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
      }
    }

    &.invert-color svg {
      path,
      polygon {
        fill: ${(props) => props.theme.palette.mainAppColor.main};
      }
    }

    &.white-transparent svg {
      path,
      polygon {
        fill: #fff;
      }
    }
  }

  &.aja {
    svg {
      g {
        stroke: ${(props) => props.theme.palette.mainAppColor.contrastText};

        + path {
          fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
        }
      }
    }

    &.invert-color svg {
      g {
        stroke: ${(props) => props.theme.palette.mainAppColor.main};
      }
    }

    &.white-transparent {
      svg {
        g {
          stroke: #fff;
        }
      }
    }

    &.fill-path {
      svg {
        #do-not-fill {
          fill: ${(props) => props.theme.palette.mainAppColor.main};
        }
        path {
          fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
        }
      }

      &.white-transparent svg {
        #do-not-fill {
          fill: transparent;
        }
        path {
          fill: #fff;
        }
      }

      &.invert-color svg {
        #do-not-fill {
          fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
        }
        path {
          fill: ${(props) => props.theme.palette.mainAppColor.main};
        }
      }
    }
  }
`;
const WeatherIcon = ({ symbol, venue, invertColors, whiteTransparentVariant, }) => {
    if (!venue) {
        return null;
    }
    if (!venue.brandSlug) {
        return null;
    }
    const imgSource = (0, weatherHelpers_1.getImgSource)(venue.brandSlug);
    const ajaClass = imgSource === "aja" ? "aja" : "general";
    const isAjaFillPath = weatherHelpers_1.ajaPathFill.includes(symbol) ? "fill-path" : "";
    const invertColorsClass = invertColors ? "invert-color" : "";
    const whiteTransparentVariantClass = whiteTransparentVariant
        ? "white-transparent"
        : "";
    return (react_1.default.createElement(Icon, { className: `weather-icon ${ajaClass} ${isAjaFillPath} ${invertColorsClass} ${whiteTransparentVariantClass}` },
        react_1.default.createElement(svg_inline_react_1.default, { src: require(`../../../../images/weather/${imgSource}/${symbol}.svg`) })));
};
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(WeatherIcon);
